import { useMe } from "src/context/MeContext";
import { isRootlyWhiteLabel } from "src/utils/brandTheme";

export function Footer() {
  const me = useMe();
  const brandTheme = me.organization?.brandTheme ?? "TIERZERO";

  // Hide footer for Rootly theme (full white-label)
  if (isRootlyWhiteLabel(brandTheme)) {
    return null;
  }

  return (
    <footer className="bg-background border-t border-border py-1">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div>
            {/* eslint-disable-next-line custom/no-hardcoded-brand-name -- legal text */}
            <p className="text-muted-foreground text-xs">&copy; {new Date().getFullYear()} TierZero AI, Inc.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
